import { observer } from 'mobx-react';
import * as React from 'react';

interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
}

const ExternalLink: React.FC<Props> = ({ children, href, ...props }) => {
  return <a href={href} target="_blank" rel="noreferrer" children={children} {...props} />;
};

export default observer(ExternalLink);
